import { render } from "./IconInvestedRoundedType1.vue?vue&type=template&id=656e8794&ts=true"
import script from "./IconInvestedRoundedType1.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__